import { useContext } from 'react';

import { CallModalContext } from './CallModalContext';

export const useCallModalContext = () => {
  return useContext(CallModalContext);
};
